import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { environment } from '@env/environment';
import { AuthService } from '@core/auth/auth.service';
import { MenuService } from '@layouts/menu/menu.service';
import { UserEditComponent } from '@routes/b2b/users/user-edit/user-edit.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';
import { SpinnerService } from '@shared/services/spinner.service';
import { ApiService } from '@shared/apis';
import { Router } from '@angular/router';
import { FileService } from '@shared/services/file.service';
import { ParamsBuilder } from '@shared/models/params-builder';
import { MfaRegisterComponent } from '@routes/auth/mfa/mfa-register/mfa-register.component';
import { Constants } from '@shared/constants/constants';

@Component({
  selector: 'app-b2b-topbar',
  templateUrl: './b2b-topbar.component.html',
  styleUrls: ['./b2b-topbar.component.scss']
})
export class B2bTopbarComponent implements OnInit {

  readonly environment = environment;
  readonly constants = Constants;
  profileName = 'prod';

  mode: string | undefined;
  myInfo: any;
  isDropDownMenu = false;
  bsModalRef: BsModalRef;
  userDetail: any = {};
  searchText: string = '';
  companyCodes: any[];
  readonly backend = environment.api.backend;

  @Output() mobileMenuButtonClicked = new EventEmitter();
  @Output() settingsButtonClicked = new EventEmitter();

  constructor(private authService: AuthService,
              private spinnerService: SpinnerService,
              private apiService: ApiService,
              private modalService: BsModalService,
              private menuService: MenuService,
              private fileService: FileService,
              private router: Router) {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isDropDownMenu = false;
  }

  ngOnInit(): void {
    this.myInfo = this.authService.getUser();
    this.companyCodes = this.authService.setCodes();
    this.profileCheck();
  }

  profileCheck() {
    switch (this.environment.environment) {
      case 'dev':
        this.profileName = 'dev';
        break;
      case 'local':
        this.profileName = 'local';
        break;
      default:
        this.profileName = '';
        break;
    }
  }

  dropDownToggle() {
    this.isDropDownMenu = !this.isDropDownMenu;
  }

  logout(ev) {
    ev.stopPropagation();
    ev.preventDefault();

    this.authService.logout();
  }

  async editUserInfo() {
    const userInfoPromise = new Promise((resolve, reject) => {
      this.spinnerService.start();
      this.apiService.user.getSimpleProfile(this.myInfo.username)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(res => {
          this.userDetail = res;
          resolve(res)
        }, err => Utils.showError(err));
    })

    await Promise.all([userInfoPromise]).then((resolve: any) => {
      this.userDetail.selectedBPs = this.userDetail.bps;
      const initialState = {
        title: 'User Edit', userInfo: this.userDetail, simpleEdit: true, profileOption: '-profile'
      };
      this.bsModalRef = this.modalService.show(UserEditComponent, {
        initialState,
        class: 'modal-lg',
        ignoreBackdropClick: true,
      });
      this.bsModalRef.content.onClose.subscribe(result => {
        this.myInfo = {
          ...this.myInfo,
          firstName: result.firstName,
          lastName: result.lastName
        };
      });
    })
  }

  globalSearch() {
    if (this.searchText.trim()) {
      this.router.navigateByUrl('/tickets?globalSearchKeyword=' + encodeURI(this.searchText.trim()));
      this.searchText = null;
    }
  }

  getUserGuide() {
    const fileName = 'B2B Portal - Request Help & Pending Dashboard User Guide_Customer_6.2.25.pdf';
    console.log('fileName: ', fileName);
    this.fileService.getUserGuide(fileName);
  }

  registerMFA() {
    this.spinnerService.start('other-layout-spinner');
    this.authService.getQRCode()
      .pipe(finalize(() => this.spinnerService.stop('other-layout-spinner')))
      .subscribe(result => {
        const { qrCode } = result;
        const initialState = {
          qrCode,
        };
        this.bsModalRef = this.modalService.show(MfaRegisterComponent, { initialState, class: 'modal-lg' });
        this.bsModalRef.content.onClose.subscribe(() => {
          Utils.showMessage('MFA device registered successfully.');
        }, err => {
          Utils.showError(err, 'MFA Register');
        });

      });
  }

  handleGoToSlapPortal() {
    window.open(Constants.LED_PORTAL_URL, '_blank');
  }
}
